import React from "react";
import { navigationPropType } from "@template/state/modules/navigation";
import CircleImageLink from "@template/components/Navigation/LargeSecondaryNavigation/CircleImageList/CircleImageLink";
import { createIdAriaDescribedBy } from "@template/helpers/navigationAccessibility";

import styles from "./index.css";

const CircleImageList = ({ item }) => {
  const { label, items } = item;
  const headerId = createIdAriaDescribedBy(label);

  return (
    <ul className={styles.circleImageList} aria-labelledby={headerId}>
      {items.map(itemCircleImage => (
        <CircleImageLink item={itemCircleImage} key={itemCircleImage.id} />
      ))}
    </ul>
  );
};

CircleImageList.propTypes = {
  item: navigationPropType.isRequired
};

export default CircleImageList;
